import { alertRequest, body } from "services/request";

const resource = "api/forwarding";

const applyBid = (params: {}, alertParams: { successAlerts: boolean; noContentAlerts: boolean } | undefined) =>
    alertRequest(`${resource}/bids/apply`, body(params), alertParams);

export { applyBid };
